import { Select } from '@radix-ui/themes';
import { useGetSlackInstallationsQuery } from '../../graphql/queries/GetSlackInstallations.generated';

interface SlackInstallationSelectProps {
  installationId?: string;
  onValueChange: (value: string) => void;
  disabled?: boolean;
}

const SlackInstallationSelect = ({
  installationId,
  onValueChange,
  disabled,
}: SlackInstallationSelectProps) => {
  const { data, loading, error } = useGetSlackInstallationsQuery();

  if (loading) {
    return (
      <Select.Root disabled={true}>
        <Select.Trigger placeholder="Loading workspaces..." style={{ width: '100%' }} />
      </Select.Root>
    );
  }

  if (error || !data) {
    return (
      <Select.Root disabled={true}>
        <Select.Trigger placeholder="Error loading Slack workspaces" style={{ width: '100%' }} />
      </Select.Root>
    );
  }

  const installations = data.slackInstallations.edges
    .map(({ node }) => node)
    .filter((installation) => installation.isActive);

  return (
    <Select.Root
      value={installationId}
      onValueChange={onValueChange}
      disabled={disabled}
    >
      <Select.Trigger
        placeholder={
          installations.length === 0
            ? 'No active Slack workspaces found'
            : 'Select a Slack workspace'
        }
        style={{ width: '100%' }}
      />
      <Select.Content>
        {installations.map((installation) => (
          <Select.Item key={installation.id} value={installation.id}>
            {installation.botUserName || installation.botUserId} (
            {installation.teamDomain || installation.slackTeamId})
          </Select.Item>
        ))}
      </Select.Content>
    </Select.Root>
  );
};

export default SlackInstallationSelect;
